import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import labels from "emun.customer/_labels";
import salesrepConfig from "emun.salesrep/salesrep.config";
import productSalesPopup from "emun.salesrep/product-sales-popup";

export default class CustomerCategoriesPurchasedController {
  constructor() {
    let $ctrl = this;
    basicController($ctrl);
    $ctrl.mode = "list";
    $ctrl.total = 0;
    $ctrl.colors = salesrepConfig.chartColors;
    $ctrl.chartOptions = {
      maintainAspectRatio: false,
      legend: {
        display: true,
        labels: {
          boxWidth: 5,
          fontSize: 10,
        },
      },
      elements: {
        rectangle: {
          borderWidth: 1,
        },
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem, data) {
            var label = data.labels[tooltipItem.index];
            let datasetLabel =
              data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return (
              label +
              ": $" +
              datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
              "  (" +
              Math.round((datasetLabel / $ctrl.total) * 100) +
              "%)"
            );
          },
        },
      },
    };
    $ctrl.labels = labels;
    $ctrl.categoryTotals = [];
    $ctrl.lytdSalesQuery = new AutoQuery({
      url:
        "QuerySalesDailyCustomerCategoryTotals.json?Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=LYTD&GroupBy=CategoryId,Category&customerId=" +
        encodeURIComponent($ctrl.customer.id),
      autoLoad: false,
      onLoaded(args) {
        if (args.total > 0) {
          args.results.forEach(function (v) {
            $ctrl.categoryTotals.forEach(function (obj) {
              if (obj.label.toUpperCase() == v.category.toUpperCase()) {
                obj.categoryId = v.categoryId;
                obj.lytd = Math.round(v.sumOrderTotal);
                var percent = Math.round((obj.ytd / obj.lytd) * 100);
                if (obj.lytd == 0) {
                  percent = 100;
                }
                if (percent < 100) {
                  obj.percent = 100 - percent;
                  obj.trend = "down";
                } else if (percent > 100) {
                  obj.percent = percent - 100;
                  obj.trend = "up";
                } else {
                  obj.percent = 100;
                  obj.trend = "neutral";
                }
              }
            });
          });
          console.info("$ctrl.categoryTotals", $ctrl.categoryTotals);
        }
      },
    });

    $ctrl.ytdSalesQuery = new AutoQuery({
      url:
        "QuerySalesDailyCustomerCategoryTotals.json?Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=YTD&GroupBy=CategoryId,Category&customerId=" +
        encodeURIComponent($ctrl.customer.id),
      autoLoad: true,
      onLoaded(args) {
        $ctrl.chartLabels = [];
        $ctrl.chartData = [];
        if (args.total > 0) {
          args.results.forEach(function (v) {
            var obj = {
              categoryId: v.categoryId,
              label: v.category,
              ytd: Math.round(v.sumOrderTotal),
              lytd: 0,
            };
            $ctrl.categoryTotals.push(obj);
            $ctrl.chartLabels.push(obj.label);
            $ctrl.chartData.push(Math.round(obj.ytd));
            $ctrl.total += obj.ytd;
          });
          $ctrl.lytdSalesQuery.load();
        }
      },
    });
  }
  showCategoryDetails(category) {
    let $ctrl = this;
    return productSalesPopup({
      context: "customer",
      category: category.categoryId,
      rep: "customer",
      customerId: $ctrl.customer.id,
      title: category.label + " Product Sales",
    }).then(function () {
      return;
    });
  }
  isBusy() {
    const $ctrl = this;
    return $ctrl.lytdSalesQuery.isBusy() || $ctrl.ytdSalesQuery.isBusy();
  }
}
